export function captureDriverLocation({ timeoutMs = 10_000, maximumAgeMs = 60_000 } = {}) {
  return new Promise((resolve) => {
    if (typeof navigator === "undefined" || !navigator.geolocation) {
      resolve({
        location: {},
        status: "UNAVAILABLE",
        warning: "Lokasi perangkat tidak tersedia.",
      });
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => resolve({
        location: {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          accuracyM: position.coords.accuracy,
        },
        status: "RESOLVED",
        warning: "",
      }),
      (error) => {
        const denied = Number(error?.code) === 1;
        resolve({
          location: {},
          status: denied ? "PERMISSION_DENIED" : "UNAVAILABLE",
          warning: denied
            ? "Akses lokasi ditolak. Foto tetap diberi timestamp tanpa koordinat."
            : "Lokasi tidak dapat direkam. Aktivitas tetap disimpan tanpa GPS.",
        });
      },
      {
        enableHighAccuracy: true,
        timeout: Math.max(1_000, Number(timeoutMs) || 10_000),
        maximumAge: Math.max(0, Number(maximumAgeMs) || 0),
      },
    );
  });
}
